import axios from '../axios'

/* 
 * 角色管理模块
 */
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/admin/role/findPage',
        method: 'post',
        data
    })
}
// 保存
export const save = (data) => {
    return axios({
        url: '/admin/role/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/admin/role/delete',
        method: 'post',
        data
    })
}
// 查询角色菜单集合
export const findRoleMenus = (params) => {
    return axios({
        url: '/admin/role/findRoleMenus',
        method: 'get',
        params
    })
}

// 查询全部
export const findAll = () => {
    return axios({
        url: '/admin/role/findAll',
        method: 'post'
    })
}

// 保存角色菜单集合
export const saveRoleMenus = (data) => {
    return axios({
        url: '/admin/role/saveRoleMenus',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/role.js